import { forwardRef, ReactElement } from "react"
import { IconButton, Tooltip } from "@mui/material"
import { GridActionsCellItemProps } from "@mui/x-data-grid-pro"

/**
 * Кнопка действия в строке DataGrid с всплывающей подсказкой (Tooltip) по label.
 *
 * Совместима с механикой `GridActionsCell`: сетка читает `props.onClick`/
 * `props.showInMenu`/`props.disabled` с этого элемента и клонирует его, внедряя
 * `onClick`/`tabIndex`/`touchRippleRef`. Поэтому Tooltip оборачивает IconButton
 * ВНУТРИ компонента (а не снаружи GridActionsCellItem), иначе сетка перезапишет
 * обработчик клика у Tooltip и кнопка перестанет работать.
 */
export const TooltipAction = forwardRef<
  HTMLButtonElement,
  GridActionsCellItemProps
>(function TooltipAction(props, ref) {
  const { label, icon, showInMenu, ...rest } =
    props as GridActionsCellItemProps & {
      icon?: ReactElement
    }

  return (
    <Tooltip title={label} arrow>
      <IconButton
        ref={ref}
        size="small"
        aria-label={typeof label === "string" ? label : undefined}
        {...(rest as Record<string, unknown>)}
      >
        {icon}
      </IconButton>
    </Tooltip>
  )
})
